import { LOCALE_STANDARD_FORMAT } from '@src/config/localisation/locale-config.constants'
import { inRange } from '@src/utils/functions/utils'

import type { TFunction } from 'next-i18next'

export const getLocalDateFromUTCDate = (utcDate: Date) => {
  return new Date(
    Date.UTC(
      utcDate.getFullYear(),
      utcDate.getMonth(),
      utcDate.getDate(),
      utcDate.getHours(),
      utcDate.getMinutes(),
      utcDate.getSeconds(),
    ),
  )
}

const getMonthFullNames = (t: TFunction) => {
  return [
    t('january'),
    t('february'),
    t('march'),
    t('april'),
    t('may'),
    t('june'),
    t('july'),
    t('august'),
    t('september'),
    t('october'),
    t('november'),
    t('december'),
  ]
}

export const formatDateToMMMM_YYYY = (date: Date, t: TFunction) => {
  const MONTH_FULL_NAMES = getMonthFullNames(t)
  const monthName = MONTH_FULL_NAMES[date.getMonth()]
  const fullYear = date.getFullYear()
  return `${monthName} ${fullYear}`
}

export const isInRangePSTDate = (startDate: string, endDate: string) => {
  const currentPSTDate = getCurrentPSTDateTime()
  const currentTimePST = currentPSTDate.getTime()
  const startTimePST = getCurrentStartOfDayInPSTEpoch(startDate)
  const endTimePST = getCurrentEndOfDayInPSTEpoch(endDate)
  return inRange(currentTimePST, startTimePST, endTimePST + 1)
}

const getCurrentPSTDateTimeString = () => {
  const currentPstDateTimeString = new Date().toLocaleString(LOCALE_STANDARD_FORMAT, {
    // eslint-disable-next-line i18next/no-literal-string
    timeZone: 'America/Los_Angeles',
  })
  return currentPstDateTimeString
}

const getCurrentPSTDateTime = () => {
  return new Date(`${getCurrentPSTDateTimeString()}-08:00`)
}

const getCurrentPSTDate = () => {
  const currentPstDateTimeString = getCurrentPSTDateTimeString()
  const [date] = currentPstDateTimeString.split(',')
  return date
}

export const getCurrentEndOfDayInPSTEpoch = (date?: string) => {
  const pstDate = date ?? getCurrentPSTDate()
  return new Date(`${pstDate} 23:59:59-08:00`).getTime()
}

const getCurrentStartOfDayInPSTEpoch = (date?: string) => {
  const pstDate = date ?? getCurrentPSTDate()
  return new Date(`${pstDate} 00:00:00-08:00`).getTime()
}

const LOCAL_MIDNIGHT_SUFFIX = 'T00:00:00'

export const sanitizeToLocalDateString = (date: string): string => {
  const utcMidnightMatch = date.match(/^(\d{4}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01]))T00:00:00(\.000)?Z$/)
  const datePart = utcMidnightMatch?.[1]
  if (datePart) {
    return `${datePart}${LOCAL_MIDNIGHT_SUFFIX}`
  }

  return date
}
